import { useCallback, useState } from 'react';

export const FAVOURITES_KEY = 'su_favourites';

export function readFavourites(): string[] {
  try {
    const raw = window.localStorage.getItem(FAVOURITES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function writeFavourites(codes: string[]): void {
  try {
    window.localStorage.setItem(FAVOURITES_KEY, JSON.stringify(codes));
  } catch {
    /* storage unavailable: keep in-memory state only */
  }
}

export interface UseFavourites {
  favourites: string[];
  isFavourite: (siteCode: string) => boolean;
  toggle: (siteCode: string) => void;
}

/** Favourite store site_codes, persisted in localStorage under "su_favourites". */
export function useFavourites(): UseFavourites {
  const [favourites, setFavourites] = useState<string[]>(readFavourites);

  const toggle = useCallback((siteCode: string) => {
    // re-read so several mounted pages/tabs do not overwrite each other
    const current = readFavourites();
    const next = current.includes(siteCode) ? current.filter((c) => c !== siteCode) : [...current, siteCode];
    writeFavourites(next);
    setFavourites(next);
  }, []);

  const isFavourite = useCallback((siteCode: string) => favourites.includes(siteCode), [favourites]);

  return { favourites, isFavourite, toggle };
}

export default useFavourites;
